import constants from "../shared/constants.json";

export const DOMAIN = "https://hahadoodle.com";
export const ROOM_PATH_PREFIX = "/room-";

export function getSharedConstant(key) {
    return constants[key];
}
